module.exports = __webpack_public_path__ + "static/media/ddt.d6495011.png";